import { render, staticRenderFns } from "./CustomerListComponent.vue?vue&type=template&id=2a9cf454&scoped=true"
import script from "./CustomerListComponent.vue?vue&type=script&lang=js"
export * from "./CustomerListComponent.vue?vue&type=script&lang=js"
import style0 from "./CustomerListComponent.vue?vue&type=style&index=0&id=2a9cf454&prod&scoped=true&lang=css"
import style1 from "./CustomerListComponent.vue?vue&type=style&index=1&id=2a9cf454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9cf454",
  null
  
)

export default component.exports